var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            {
              staticClass:
                "d-flex align-items-center justify-content-start mb-1 mb-md-0",
              attrs: { md: "8" },
            },
            [
              _c("p", { staticClass: "h5 mt-50 mr-75 ml-50" }, [
                _vm._v(" 일별/누적 "),
              ]),
              _c(
                "b-form-radio-group",
                {
                  on: { change: _vm.changePrefixSum },
                  model: {
                    value: _vm.query.isPrefixSum,
                    callback: function ($$v) {
                      _vm.$set(_vm.query, "isPrefixSum", $$v)
                    },
                    expression: "query.isPrefixSum",
                  },
                },
                [
                  _c("b-form-radio", { attrs: { value: false } }, [
                    _vm._v(" 일별 (기간:최대30일) "),
                  ]),
                  _c("b-form-radio", { attrs: { value: true } }, [
                    _vm._v(" 누적 (기간:최대1년) "),
                  ]),
                ],
                1
              ),
              _c("b-form-datepicker", {
                staticClass: "el-def",
                staticStyle: { width: "240px" },
                attrs: { placeholder: "조회기간(Fr)" },
                model: {
                  value: _vm.query.startDate,
                  callback: function ($$v) {
                    _vm.$set(_vm.query, "startDate", $$v)
                  },
                  expression: "query.startDate",
                },
              }),
              _c("label", { staticClass: "ml-50 mr-50" }, [_vm._v("~")]),
              _c("b-form-datepicker", {
                staticClass: "el-def",
                staticStyle: { width: "240px" },
                attrs: { placeholder: "조회기간(To)" },
                model: {
                  value: _vm.query.endDate,
                  callback: function ($$v) {
                    _vm.$set(_vm.query, "endDate", $$v)
                  },
                  expression: "query.endDate",
                },
              }),
            ],
            1
          ),
          _c(
            "b-col",
            {
              staticClass: "d-flex align-items-center justify-content-end",
              attrs: { md: "4" },
            },
            [
              _c(
                "b-button",
                {
                  staticClass: "btn-search",
                  attrs: { variant: "primary" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.fetchData()
                    },
                  },
                },
                [_vm._v(" 조회 ")]
              ),
              _c(
                "b-button",
                {
                  staticClass: "btn-search ml-1",
                  attrs: { variant: "outline-dark" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.excelDownload()
                    },
                  },
                },
                [
                  _c("feather-icon", {
                    staticClass: "mr-50",
                    attrs: { icon: "DownloadIcon" },
                  }),
                  _c("span", [_vm._v("엑셀 다운로드")]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-row",
        { staticClass: "mt-2" },
        [
          _c(
            "b-col",
            {
              staticClass:
                "d-flex align-items-center justify-content-start mb-1 mb-md-0",
              attrs: { cols: "12" },
            },
            [
              _c(
                "b-table-simple",
                {
                  staticStyle: { "max-height": "65vh" },
                  attrs: { bordered: "", responsive: "", "sticky-header": "" },
                },
                [
                  _c("colgroup", [
                    _c("col", { staticStyle: { width: "140px" } }),
                    _c("col", { staticStyle: { width: "100px" } }),
                    _c("col", { staticStyle: { width: "100px" } }),
                    _c("col", { staticStyle: { width: "100px" } }),
                    _c("col", { staticStyle: { width: "100px" } }),
                    _c("col", { staticStyle: { width: "100px" } }),
                    _c("col", { staticStyle: { width: "100px" } }),
                    _c("col", { staticStyle: { width: "100px" } }),
                    _c("col", { staticStyle: { width: "100px" } }),
                    _c("col", { staticStyle: { width: "100px" } }),
                    _c("col", { staticStyle: { width: "100px" } }),
                  ]),
                  _c(
                    "b-thead",
                    { attrs: { "head-variant": "light" } },
                    [
                      _c(
                        "b-tr",
                        [
                          _c("b-th", { attrs: { rowspan: "2" } }, [
                            _vm._v(" 구분 "),
                          ]),
                          _c("b-th", { attrs: { colspan: "2" } }, [
                            _vm._v(" 메디컬트렌드 "),
                          ]),
                          _c("b-th", { attrs: { colspan: "2" } }, [
                            _vm._v(" Weekly Choice "),
                          ]),
                          _c("b-th", { attrs: { colspan: "2" } }, [
                            _vm._v(" 약품정보 "),
                          ]),
                          _c("b-th", { attrs: { colspan: "2" } }, [
                            _vm._v(" 공지사항 "),
                          ]),
                          _c("b-th", { attrs: { colspan: "2" } }, [
                            _vm._v(" 이벤트 "),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "b-tr",
                        [
                          _c("b-th", { staticStyle: { top: "38.55px" } }, [
                            _vm._v(" 댓글 수 "),
                          ]),
                          _c("b-th", { staticStyle: { top: "38.55px" } }, [
                            _vm._v(" 작성자 수 "),
                          ]),
                          _c("b-th", { staticStyle: { top: "38.55px" } }, [
                            _vm._v(" 댓글 수 "),
                          ]),
                          _c("b-th", { staticStyle: { top: "38.55px" } }, [
                            _vm._v(" 작성자 수 "),
                          ]),
                          _c("b-th", { staticStyle: { top: "38.55px" } }, [
                            _vm._v(" 댓글 수 "),
                          ]),
                          _c("b-th", { staticStyle: { top: "38.55px" } }, [
                            _vm._v(" 작성자 수 "),
                          ]),
                          _c("b-th", { staticStyle: { top: "38.55px" } }, [
                            _vm._v(" 댓글 수 "),
                          ]),
                          _c("b-th", { staticStyle: { top: "38.55px" } }, [
                            _vm._v(" 작성자 수 "),
                          ]),
                          _c("b-th", { staticStyle: { top: "38.55px" } }, [
                            _vm._v(" 댓글 수 "),
                          ]),
                          _c("b-th", { staticStyle: { top: "38.55px" } }, [
                            _vm._v(" 작성자 수 "),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.data.length > 0
                    ? _c(
                        "b-tbody",
                        _vm._l(_vm.data, function (m, idx) {
                          return _c(
                            "b-tr",
                            {
                              key: "tr-" + idx,
                              class: {
                                "table-active": idx === _vm.data.length - 1,
                              },
                            },
                            [
                              _c("b-td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.data.length === 1 && m.isPrefixSum
                                      ? "누적 수"
                                      : m.isPrefixSum
                                      ? "합계"
                                      : m.date
                                  )
                                ),
                              ]),
                              _c("b-td", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("$numberFormatter")(
                                      m.medicalTrendTotalCount
                                    )
                                  )
                                ),
                              ]),
                              _c("b-td", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("$numberFormatter")(
                                      m.medicalTrendGroupCount
                                    )
                                  )
                                ),
                              ]),
                              _c("b-td", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("$numberFormatter")(
                                      m.weeklyChoiceTotalCount
                                    )
                                  )
                                ),
                              ]),
                              _c("b-td", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("$numberFormatter")(
                                      m.weeklyChoiceGroupCount
                                    )
                                  )
                                ),
                              ]),
                              _c("b-td", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("$numberFormatter")(
                                      m.drugInfoTotalCount
                                    )
                                  )
                                ),
                              ]),
                              _c("b-td", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("$numberFormatter")(
                                      m.drugInfoGroupCount
                                    )
                                  )
                                ),
                              ]),
                              _c("b-td", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("$numberFormatter")(
                                      m.noticeTotalCount
                                    )
                                  )
                                ),
                              ]),
                              _c("b-td", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("$numberFormatter")(
                                      m.noticeGroupCount
                                    )
                                  )
                                ),
                              ]),
                              _c("b-td", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("$numberFormatter")(
                                      m.eventTotalCount
                                    )
                                  )
                                ),
                              ]),
                              _c("b-td", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("$numberFormatter")(
                                      m.eventGroupCount
                                    )
                                  )
                                ),
                              ]),
                            ],
                            1
                          )
                        }),
                        1
                      )
                    : _c(
                        "b-tbody",
                        [
                          _c(
                            "b-tr",
                            [
                              _c("b-td", { attrs: { colspan: "11" } }, [
                                _c(
                                  "div",
                                  {
                                    attrs: {
                                      role: "alert",
                                      "aria-live": "polite",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "text-center my-2" },
                                      [_vm._v(" 일치하는 데이터가 없습니다. ")]
                                    ),
                                  ]
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }